export default "__VITE_ASSET__DuORDDyl__"